import React from 'react';
import { ButtonPrimaryLink, ButtonSecondaryLink } from '../LinkV2';
import { useS4AMastheadContext } from '../S4AMastheadProvider';
import { login, logout } from '../../utils/auth';
import { getInternalHref } from '../../utils/getInternalHref';
export const AuthButton = ({ onClick, userState, size, fullWidth, trackingCategory, className, }) => {
    const { mastheadData } = useS4AMastheadContext();
    const headerEntry = mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.fields.header;
    const useLogin = userState === 'loggedOut';
    const label = useLogin
        ? headerEntry.fields.loginButtonText
        : headerEntry.fields.logoutButtonText;
    const { clientId, getLoginRedirectUri } = useS4AMastheadContext();
    return (React.createElement(ButtonSecondaryLink, { className: className, label: label, size: size, "data-testid": useLogin ? 'root-login' : 'root-logout', onClick: () => {
            onClick === null || onClick === void 0 ? void 0 : onClick();
            if (useLogin) {
                login(clientId, getLoginRedirectUri());
            }
            else {
                logout(clientId);
            }
        }, fullWidth: fullWidth, trackingLabel: useLogin ? 'Log In' : 'Log Out', trackingCategory: trackingCategory, openInNewTab: false }));
};
export const ClaimButton = ({ onClick, userState, size, fullWidth, trackingCategory, className, colorSet, }) => {
    const { isFrodor } = useS4AMastheadContext();
    const useDashboard = userState === 'claimed';
    const { mastheadData } = useS4AMastheadContext();
    const headerEntry = mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.fields.header;
    const label = useDashboard
        ? headerEntry.fields.dashboardText
        : headerEntry.fields.getAccessText;
    return (React.createElement(ButtonPrimaryLink, { className: className, size: size, "data-testid": useDashboard ? 'navigation-dashboard' : 'navigation-claim', href: useDashboard
            ? getInternalHref('/c', isFrodor)
            : getInternalHref('/claim', isFrodor), onClick: onClick, trackingCategory: trackingCategory, trackingLabel: useDashboard ? 'dashboard' : `Get Access (${userState})`, fullWidth: fullWidth, colorSet: colorSet ? undefined : 'base', UNSAFE_colorSet: colorSet, label: label }));
};
//# sourceMappingURL=Actions.js.map